import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			loadingText: 'Loading',
			buttonProps: {
				text: 'Download Historic Prices',
			},
			useSpinner: true,
			downloadIcon: 'base.icons.download',
			spinnerIcon: 'base.icons.spinner',
			noDataOptions: {
				hide: false,
				noDataPlaceholder: 'no data',
			},
			noDataText: {
				queryOptionsType: 'none',
				value: '<p>No data to download</p>',
			},
			// overridden by mock data
			csvDownloaderOptions: {
				filename: {
					queryOptionsType: 'none',
					value: '',
				},
				columns: [],
				rowsQuery: {
					queryOptionsType: 'none',
					value: '',
				},
			},
		},
	},
};
